var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-coupone-record-used" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            { staticClass: "search-form" },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: { inline: true, model: _vm.searchForm },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放流水号" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入发放流水号",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.issueCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "issueCode", $$v)
                          },
                          expression: "searchForm.issueCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "优惠券ID" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入优惠券ID", clearable: "" },
                        model: {
                          value: _vm.searchForm.couponId,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "couponId", $$v)
                          },
                          expression: "searchForm.couponId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "优惠券名称" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入优惠券名称",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.couponName,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "couponName", $$v)
                          },
                          expression: "searchForm.couponName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "卡号" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入卡号", clearable: "" },
                        model: {
                          value: _vm.searchForm.cardNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "cardNo", $$v)
                          },
                          expression: "searchForm.cardNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入手机号", clearable: "" },
                        model: {
                          value: _vm.searchForm.mobileNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "mobileNo", $$v)
                          },
                          expression: "searchForm.mobileNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "关联订单号" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入关联订单号",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "orderNo", $$v)
                          },
                          expression: "searchForm.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "核销状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择核销状态",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.verifyStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "verifyStatus", $$v)
                            },
                            expression: "searchForm.verifyStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "未核销", value: "0" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "已核销", value: "1" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择发放状态",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.sendStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "sendStatus", $$v)
                            },
                            expression: "searchForm.sendStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "发放中", value: "0" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "已发放", value: "1" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "发放失败", value: "2" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "会员类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择会员类型",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.registerType,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "registerType", $$v)
                            },
                            expression: "searchForm.registerType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "用户注册", value: "0" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "后台注册", value: "1" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建日期" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          clearable: "",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        on: { change: _vm.handleDateChange },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("查询")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleExport },
                        },
                        [_vm._v("导出")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.recordUsedList, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "issueCode",
                  label: "发放流水号",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "couponId", label: "券ID", "min-width": "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponName",
                  label: "券名称",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "cardNo", label: "卡号", "min-width": "150" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "mobile", label: "手机号", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(scope.row.mobile || scope.row.phone || "") +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userName",
                  label: "用户名",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "verifyStatus",
                  label: "核销状态",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getVerifyStatusType(
                                scope.row.verifyStatus
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getVerifyStatusText(scope.row.verifyStatus)
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "关联订单号",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sendStatus",
                  label: "发放状态",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getSendStatusType(scope.row.sendStatus),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getSendStatusText(scope.row.sendStatus)
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponNum",
                  label: "优惠券数量",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderStore",
                  label: "核销门店",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "registerType",
                  label: "会员类型",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              scope.row.registerType == 0
                                ? "用户注册"
                                : "后台注册"
                            ) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "领取时间",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.formatDate(scope.row.createTime)) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "更新时间",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.formatDate(scope.row.updateTime)) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.searchForm.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.searchForm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }